import { LitElement, html } from "../vendor/lit-element/lit-element";

class Bones extends LitElement {
  render() {
    return html`<svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 84.81 35.28"
      height="40"
      width="96"
    >
      <defs>
        <style>
          .plus,
          .minus {
            display: none;
          }
          .plus.active,
          .minus.active {
            display: block;
          }
          .cls-1 {
            fill: #38a947;
          }
          .cls-2 {
            fill: #e1e2e3;
          }
          .cls-3 {
            fill: #d0d2d3;
          }
          .cls-4 {
            fill: #231f20;
            opacity: 0.2;
          }
          .cls-5 {
            fill: none;
            stroke: #231f20;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 0.5px;
          }
        </style>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="cursor">
          <path
            class="cls-1 plus"
            d="M65.87,17.55a8.87,8.87,0,1,0,8.86,8.86A8.86,8.86,0,0,0,65.87,17.55Zm4.09,10a.22.22,0,0,1-.07.16.2.2,0,0,1-.16.07H67.32c-.07,0-.1,0-.1.1v2.39a.2.2,0,0,1-.07.16.19.19,0,0,1-.16.07H64.77a.24.24,0,0,1-.23-.23V27.88c0-.07,0-.1-.09-.1H62a.22.22,0,0,1-.22-.23V25.31a.23.23,0,0,1,.06-.16.26.26,0,0,1,.16-.07h2.44a.08.08,0,0,0,.09-.09V22.56a.19.19,0,0,1,.07-.16.2.2,0,0,1,.16-.07H67a.24.24,0,0,1,.23.23V25c0,.06,0,.09.1.09h2.41a.24.24,0,0,1,.23.23Z"
          />
          <path
            class="cls-2"
            d="M77.7.79a8.28,8.28,0,0,0-6.52,8.42,6.65,6.65,0,0,1,5.14,2.2,9.59,9.59,0,0,0,1.88,2,3.38,3.38,0,0,0,2.64.32,5.11,5.11,0,0,0,2.28-1.44,4.67,4.67,0,0,0,1.44-3.27,2.88,2.88,0,0,0-2-2.75c-1.29-.31-2.58.51-3.91.51A2.85,2.85,0,0,1,76,5.2a2.28,2.28,0,0,1,.89-2.83c.23-.13.49-.21.71-.34a.89.89,0,0,0,.47-.6A.65.65,0,0,0,77.7.79Z"
          />
          <path
            class="cls-3"
            d="M82.3,6.17a1.83,1.83,0,0,0-1.86.65,4.49,4.49,0,0,0-.85,1.9,8.58,8.58,0,0,1-.61,2A2.29,2.29,0,0,1,77.44,12c-.15,0-.36.09-.35.24a.31.31,0,0,0,.06.16,3.33,3.33,0,0,0,3.07,1.29,5.11,5.11,0,0,0,3-1.61A5.15,5.15,0,0,0,84.54,9.9a3.35,3.35,0,0,0-.31-2.5A3.16,3.16,0,0,0,82.3,6.17Z"
          />
          <path
            class="cls-3"
            d="M2.7,18.32A2.22,2.22,0,0,0,1.32,20.7,3.42,3.42,0,0,0,3,23.07a7.24,7.24,0,0,1,1.73,1.15,3.9,3.9,0,0,1,.57,3,5.11,5.11,0,0,0,.29,3.08,2.45,2.45,0,0,0,3.34.78A3.85,3.85,0,0,1,5.24,32a3.85,3.85,0,0,1-2.6-2.73,27.68,27.68,0,0,1-.19-2.89,5.18,5.18,0,0,0-.74-2.1A14.51,14.51,0,0,1,.48,22.36a3,3,0,0,1,.17-2.53A3.24,3.24,0,0,1,2.7,18.32Z"
          />
          <path
            class="cls-4"
            d="M82.79,12.62a6.64,6.64,0,0,1-5.85-2.73,7.57,7.57,0,0,0-8.61-2.44C66.17,8.35,36.82,20.09,31,21c-5.39.78-10.68,2.6-15.85,4.25-1.52.48-3.2.82-4.44,1.89a6.35,6.35,0,0,0-1.77,4,23.05,23.05,0,0,1,6.22-3.66C18,26.52,33,22.64,33,22.64A160.17,160.17,0,0,0,54.67,15c10.61-4.73,16.16-5.66,16.16-5.66a5.51,5.51,0,0,1,4.64,1.28c2,1.87,2.2,3.43,4.36,3.26a4,4,0,0,0,3-1.28"
          />
          <path
            class="cls-5"
            d="M45.26,11.87A132.79,132.79,0,0,0,64.19,4.05a45.67,45.67,0,0,1,5.9-2.84A13.3,13.3,0,0,1,76.53.36,2.14,2.14,0,0,1,77.68.8a.87.87,0,0,1,.17,1.12A2.46,2.46,0,0,0,75.79,4.3a2.62,2.62,0,0,0,2.1,2.51c1.51.25,3-.9,4.51-.59a3,3,0,0,1,2.15,3.24,5.18,5.18,0,0,1-2.2,3.5,4,4,0,0,1-3.54.87c-1.47-.5-2.17-2.16-3.34-3.19a6.13,6.13,0,0,0-4.64-1.28,18,18,0,0,0-4.76,1.33l-23.84,9C35.45,22.05,28.55,24,21.58,25.65c-3.63.85-7.4,1.65-10.42,3.83-1.55,1.11-3,2.62-4.92,2.69a3.68,3.68,0,0,1-3.65-2.93c-.19-1.06.1-2.18-.14-3.24C2,24.19.12,22.82.26,21a3.42,3.42,0,0,1,3-2.77,13.62,13.62,0,0,1,4.39.41c6.62,1.17,19.93-1.75,19.93-1.75S40.9,13.31,45.26,11.87Z"
          />
        </g>
      </g>
    </svg>`;
  }
}

customElements.define("bone-icon", Bones);
